import { CSSProperties } from "react";
// 常量
import { SuperSelectProps } from "../SuperSelect/interface";
import { TextAreaRowProps } from "../TextAreaRow/interface";
import { RuleRadioGroupProps } from "../GroupSearch/interface";

export interface FieldGroupSearchProps {
  /** 样式 */
  style?: CSSProperties,
  /** 类名 */
  className?: string;
  /** 组合值 */
  value?: any;
  /** 默认组合值 */
  defaultValue?: any;
  /** 是否禁用 */
  disabled?: boolean;
  /** 类型下拉配置 */
  typeSuperSelectProps?: SuperSelectProps;
  /** 字段下拉配置 */
  fieldSuperSelectProps?: SuperSelectProps;
  /** 匹配规则按钮组配置 */
  matchRuleRadioGroupProps?: RuleRadioGroupProps;
  /** 末尾匹配值多行输入框配置 */
  valueAreaRowProps?: TextAreaRowProps;
  /** 自定义 type、field、rules\value 的字段名称 */
  fieldNames?: GroupSearchFieldNamesType;
  /** 需要转换成大写的字段 */
  upperCaseSearchType?: string[];
  /** value改变回调 */
  onChange?: (value?: any) => void;
};

export interface GroupSearchFieldNames {
  /** 搜索字段类型 */
  type: string;
  /** 搜索字段 */
  field: string
  /** 匹配规则 */
  rule: string;
  /** 值 */
  value: string;
}

export type GroupSearchFieldNamesType = Partial<GroupSearchFieldNames>;
/** 默认字段名称 */
export const DEFAULT_FIELD_NAMES: GroupSearchFieldNames = {
  type: 'type',
  field: 'field',
  rule: 'rule',
  value: 'value',
};
